import { combineReducers } from "redux"
import { action } from "./actionReducer"

const activityReducers = combineReducers({
  action
})

export default activityReducers
